import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import { useHistory } from "react-router";
import { SliderPage } from ".";
import { InternalAgentSelect } from "../components";
import AddressForm from "../components/order/AddressForm";
import AppointmentDateSelect from "../components/order/AppointmentDateSelect";
import { TempPasswordNotice } from "../components/order/TempPasswordNotice";
import { useAuthentication } from "../context/AuthenticationContext";
import { useUser } from "../context/UserContext";
import { isInternal } from "../helpers";
import { APPOINTMENT_SKUS, NON_DISCOUNT_APPT_SKUS } from "../helpers/constants";
import { Input } from "../components/fields";

const UserLogin = () => {
  const { user } = useUser();
  const history = useHistory();
  const { setRedirectPath } = useAuthentication();
  if (user || isInternal()) return null;
  const handleLogin = (path) => {
    setRedirectPath("/submit");
    history.push(path);
  };
  return (
    <div className="mb-5">
      <h2>We use Uplist</h2>
      <p className="text-muted">
        In order to submit this request, you will need to have an Uplist
        account. Your account links your order to your profile in our system to
        ensure order accuracy.
      </p>
      <TempPasswordNotice />
      <Row>
        <Col>
          <Button onClick={() => handleLogin("/login")} size="lg" block>
            Log In
          </Button>
        </Col>
        <Col xs="auto" className="d-flex align-items-center">
          OR
        </Col>
        <Col>
          <Button onClick={() => handleLogin("/signup")} size="lg" block>
            Sign Up
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const SubmitPage = () => {
  const separate_selected = useWatch({ name: "8001" });
  const order_label = `for your ${
    separate_selected ? "other" : ""
  } appointments`;

  return (
    <SliderPage title="Submit">
      <AppointmentDateSelect
        group_name="sign"
        show_skus={["8001"]}
        group_label="to install your sign"
      />

      <AppointmentDateSelect
        group_name="order"
        show_skus={[...APPOINTMENT_SKUS, ...NON_DISCOUNT_APPT_SKUS]}
        group_label={order_label}
      />
      <div className="mb-5">
        <Input
          sku="notes.order"
          as="textarea"
          label="Special Instructions"
          rows={6}
        />
      </div>
      <UserLogin />
      <InternalAgentSelect />
      {isInternal() && <AddressForm />}
      {!isInternal() && (
        <p className="text-muted">
          By engaging services performed by Realfoto Media Inc. you acknowledge
          your acceptance of the Policies, Terms, and Conditions available{" "}
          <a
            className="text-link"
            href="https://realfoto.ca/terms"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          . Barring situations of gross negligence, damages are limited to the
          total value of the services provided.
        </p>
      )}
    </SliderPage>
  );
};

export default SubmitPage;
